import { TitleHead } from "../../types/data";
import SortIcon from "src/components/ui-icons/table/SortIcon";

type SortConfig = {
  field: string | null;
  direction: 'asc' | 'desc' | null;
};

const COLUMNS = [
  {
    prescription: {
      width: '190px',
      isFilter: true,
      sortField: 'prescriptionNumber'
    },
    license: {
      width: '210px',
      isFilter: true,
      sortField: 'documentNumber'
    }
  },
  {
    prescription: {
      width: '100px'
    },
    license: {
      width: '100px'
    }
  },
  {
    prescription: {
      width: '160px'
    },
    license: {
      width: '190px'
    }
  },
  {
    prescription: {
      width: '180px',
      isFilter: true,
      sortField: 'dateVerification'
    },
    license: {
      width: '170px'
    }
  },
  {
    prescription: {
      width: '170px'
    },
    license: {
      width: '170px'
    }
  },
  {
    prescription: {
      width: '140px'
    },
    license: {
      width: '170px'
    }
  },
  {
    prescription: {
      width: '170px',
      isFilter: true,
      sortField: 'deadlineExecutionOrder'
    },
    license: {
      width: '150px',
      isFilter: true,
      sortField: 'startDateDocument'
    }
  },
  {
    prescription: {
      width: '210px',
      isFilter: true,
      sortField: 'actualClosingDatePrescription'
    },
    license: {
      width: '170px',
      isFilter: true,
      sortField: 'expirationDateDocument'
    }
  },
  {
    prescription: {
      width: '150px'
    },
    license: {
       width: '150px'
    }
  }
];

type TableHeadProps = {
  data: TitleHead[];
  isLicenses?: boolean;
  onSort?: (field: string) => void;
  sortConfig?: SortConfig;
};

function TableHead({ data, isLicenses, onSort, sortConfig }: TableHeadProps) {
  return (
    <thead>
      <tr>
        {data.map((item, index) => {
          const column = isLicenses ? COLUMNS[index].license : COLUMNS[index].prescription;
          const isActive = column.sortField && sortConfig?.field === column.sortField;

          return (
            <th
              key={item.id}
              className="font-medium border-b border-[#012169] text-black text-left pr-5 pb-5"
              style={{ width: column.width }}>
              <div
                className={`flex gap-1 items-center ${column.isFilter ? 'cursor-pointer select-none hover:text-[#012169]' : ''}`}
                onClick={() => column.sortField && onSort && onSort(column.sortField)}
              >
                {item.title}
                {column.isFilter && (
                  <span className="shrink-0">
                    <SortIcon sortDirection={isActive ? sortConfig?.direction || 'default' : 'default'} />
                  </span>
                )}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  )
}

export default TableHead;
